import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useI18n } from "../../../i18n";
import { fmtDate, fmtMoney } from "../../../lib/format";
import { StatusBadge } from "../../../components/common/StatusBadge";

export const OrderRow = ({ order }) => {
  const { t } = useI18n();
  return (
    <Link to={`/app/orders/${order.local_id}`} data-testid={`order-row-${order.local_id}`} className="flex items-center gap-3 px-4 py-3.5 transition-colors hover:bg-slate-50">
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-navy">{order.softone_doc_no || t(order.status === "pending_approval" ? "orders.pendingNoDoc" : `status.${order.status}`)}</p>
        <p className="mt-0.5 text-xs text-slate-500">
          {fmtDate(order.order_date)} · {t("checkout.itemsCount", { n: order.lines.length })}
          {order.requested_delivery_date && <> · {t("orders.deliveryDate")} {fmtDate(order.requested_delivery_date)}</>}
        </p>
      </div>
      <div className="flex flex-col items-end gap-1">
        <span className="text-sm font-semibold tabular-nums text-navy">{fmtMoney(order.gross_total)}</span>
        <StatusBadge status={order.status} customer />
      </div>
      <ChevronRight className="h-4 w-4 shrink-0 text-slate-300" />
    </Link>
  );
};
